<template>
  <div>
    <div v-if="isLoading" class="loader">
      <div
        class="row text-center pl-3 pr-3"
        style="
          align-items: baseline;
          flex-direction: row;
          justify-content: space-between;
          align-items: flex-end;
        "
      >
        <idx-skeleton width="30" height="300" radius="0" class="m-1" />
        <idx-skeleton width="30" height="250" radius="0" class="m-1" />
        <idx-skeleton width="30" height="200" radius="0" class="m-1" />
        <idx-skeleton width="30" height="100" radius="0" class="m-1" />
        <idx-skeleton width="30" height="90" radius="0" class="m-1" />
        <idx-skeleton width="30" height="60" radius="0" class="m-1" />
        <idx-skeleton width="30" height="70" radius="0" class="m-1" />
        <idx-skeleton width="30" height="80" radius="0" class="m-1" />
      </div>
    </div>
    <div v-else-if="!isLoading && existValue()">
      <highcharts :options="chartOptions" ref="myChart"></highcharts>
    </div>
    <div class="graph" v-else-if="!isLoading && !existValue()">
      {{ this.$t('reports.npsBar.noData') }}
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import idxSkeleton from '@/components/molecules/idx-skeleton';
import EventBus from '../../../../eventBus';

export default {
  name: 'Column',
  components: {
    idxSkeleton,
  },
  data: () => ({
    chartOptions: null,
    chartTitle: '',
    plotOptions: null,
    loader: true,
    series: [],
    userAuth: null,
    colors: null,
    xAxis: null,
    isLoading: true,
  }),
  watch: {
    grades: async function watchGrades() {
      this.loader = true;
      await this.setParams();
      await this.renderBars();
      this.loader = false;
    },
    myMetric: function watchMyMetric() {
      this.changeLabel();
    },
    calendarDates: async function watchDates() {
      this.isLoading = true;
      await this.setParams();
      await this.renderBars([
        this.promoters > 0 ? this.promoters : 0,
        this.passive > 0 ? this.passive : 0,
        this.detractors > 0 ? this.detractors : 0,
      ]);
    },
  },
  computed: {
    ...mapState('dashboard', ['grades']),
    ...mapState('actions', ['myActionId']),
    ...mapState('branches', ['myIh1', 'myIh2']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('authentication', ['userProfile']),
  },
  methods: {
    ...mapActions('dashboard', ['getGradesByDate']),
    ...mapActions('calendar', ['setDefaultDates']),

    existValue() {
      const length = this.chartOptions.series[0].data.length;

      if (
        length === 11 &&
        this.chartOptions.series[0].data[0] === 0 &&
        this.chartOptions.series[0].data[1] === 0 &&
        this.chartOptions.series[0].data[2] === 0 &&
        this.chartOptions.series[0].data[3] === 0 &&
        this.chartOptions.series[0].data[4] === 0 &&
        this.chartOptions.series[0].data[5] === 0 &&
        this.chartOptions.series[0].data[6] === 0 &&
        this.chartOptions.series[0].data[7] === 0 &&
        this.chartOptions.series[0].data[8] === 0 &&
        this.chartOptions.series[0].data[9] === 0 &&
        this.chartOptions.series[0].data[10] === 0
      ) {
        return false;
      } else if (
        length === 5 &&
        this.chartOptions.series[0].data[0] === 0 &&
        this.chartOptions.series[0].data[1] === 0 &&
        this.chartOptions.series[0].data[2] === 0 &&
        this.chartOptions.series[0].data[3] === 0 &&
        this.chartOptions.series[0].data[4] === 0
      ) {
        return false;
      } else if (
        length === 2 &&
        this.chartOptions.series[0].data[0] === 0 &&
        this.chartOptions.series[0].data[1] === 0
      ) {
        return false;
      }
      return true;
    },

    async setParams() {
      if (this.grades) {
        if (
          this.myMetric === 'nps-1-5' ||
          this.myMetric === 'ces-1-5' ||
          this.myMetric === 'csat-1-5' ||
          this.myMetric === 'csat-1-5(media)' ||
          this.myMetric === '5-stars'
        ) {
          this.series = [
            {
              name: this.$t('reports.verticalColumn.chartSeries'),
              colorByPoint: true,
              data: [
                this.grades['5'],
                this.grades['4'],
                this.grades['3'],
                this.grades['2'],
                this.grades['1'],
              ],
              cursor: 'pointer',
              point: {
                events: {
                  click: (e) => this.handleClick(e.point.category),
                },
              },
            },
          ];
          this.colors = ['#4ce595', '#4ce595', '#ecdb12', '#d62027', '#d62027'];
          this.xAxis = {
            categories: ['5', '4', '3', '2', '1'],
            visible: true,
            labels: {},
          };

          this.plotOptions = {
            column: {
              pointPadding: 0.1,
              borderWidth: 0,
              dataLabels: {
                enabled: true,
              },
            },
            series: {
              groupPadding: 0,
              pointPadding: 0.05,
              pointWidth: 55,
              borderWidth: 0,
            },
          };
        }

        if (this.myMetric === 'like-dislike') {
          this.series = [
            {
              name: this.$t('reports.verticalColumn.chartSeries'),
              colorByPoint: true,
              data: [this.grades['1'], this.grades['0']],
              cursor: 'pointer',
              point: {
                events: {
                  click: (e) => this.handleClick(e.point.category),
                },
              },
            },
          ];
          this.colors = ['#4ce595', '#d62027'];
          this.xAxis = {
            categories: ['1', '0'],
            visible: true,
            labels: {},
          };

          this.plotOptions = {
            column: {
              pointPadding: 0.1,
              borderWidth: 0,
              dataLabels: {
                enabled: true,
              },
            },
            series: {
              groupPadding: 0,
              pointPadding: 0.05,
              pointWidth: 55,
              borderWidth: 0,
            },
          };
        }

        if (
          this.myMetric === 'nps-0-10' ||
          this.myMetric === 'csat-0-10(media)'
        ) {
          this.series = [
            {
              name: this.$t('reports.verticalColumn.chartSeries'),
              colorByPoint: true,
              data: [
                this.grades['10'],
                this.grades['9'],
                this.grades['8'],
                this.grades['7'],
                this.grades['6'],
                this.grades['5'],
                this.grades['4'],
                this.grades['3'],
                this.grades['2'],
                this.grades['1'],
                this.grades['0'],
              ],
              cursor: 'pointer',
              point: {
                events: {
                  click: (e) =>
                    this.userProfile.permissions.answers.menu
                      ? this.handleClick(e.point.category)
                      : '',
                },
              },
            },
          ];

          this.colors = [
            '#4ce595',
            '#4ce595',
            '#ecdb12',
            '#ecdb12',
            '#d62027',
            '#d62027',
            '#d62027',
            '#d62027',
            '#d62027',
            '#d62027',
            '#d62027',
          ];

          this.xAxis = {
            categories: [
              '10',
              '9',
              '8',
              '7',
              '6',
              '5',
              '4',
              '3',
              '2',
              '1',
              '0',
            ],
            visible: true,
            labels: {},
          };

          this.plotOptions = {
            column: {
              pointPadding: 0.1,
              borderWidth: 2,
              dataLabels: {
                enabled: true,
              },
            },
            series: {
              groupPadding: 0,
              pointPadding: 0.05,
              borderWidth: 0,
            },
          };
        }
      }
    },

    async renderBars() {
      let max;

      if (this.series.length > 0) {
        max = this.series[0].data.reduce((a, b) => Math.max(a, b));

        this.chartOptions = {
          title: {
            align: 'left',
            text: this.chartTitle,
            style: {
              color: '#5f6368',
            },
          },
          chart: {
            type: 'column',
            height: 350,
            spacing: [25, 20, 25, 20],
            borderRadius: 4,
            borderColor: 'rgba(0, 0, 0, 0.09)',
            borderWidth: 0.7,
            style: {
              fontFamily:
                '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
              fontSize: '12px',
              width: '100%',
            },
          },
          xAxis: this.xAxis,
          yAxis: {
            gridLineWidth: 0,
            labels: {
              enabled: false,
            },
            max,
            title: {
              text: '',
            },
            stackLabels: {
              enabled: true,
              fontWeight: 'bold',
            },
          },
          series: this.series,
          legend: {
            enabled: false,
          },
          plotOptions: this.plotOptions,
          colors: this.colors,
        };
      }
    },
    handleClick(grade) {
      this.$router.push({ name: 'Respostas', query: { grade } });
    },
    changeLabel() {
      if (this.myMetric.indexOf('nps') !== -1) {
        this.chartTitle = this.$t('reports.verticalColumn.chartTitle');
      } else if (this.myMetric.indexOf('ces') !== -1) {
        this.chartTitle = this.$t('reports.verticalColumn.cesChartTitle');
      } else if (this.myMetric === 'csat-1-5') {
        this.chartTitle = this.$t('reports.verticalColumn.csatChartTitle');
      } else if (this.myMetric === 'csat-1-5(media)') {
        this.chartTitle = this.$t(
          'reports.verticalColumn.csatAverageChartTitle',
        );
      } else if (this.myMetric === 'csat-0-10(media)') {
        this.chartTitle = this.$t(
          'reports.verticalColumn.csat0to10AverageChartTitle',
        );
      } else if (this.myMetric === '5-stars') {
        this.chartTitle = this.$t('reports.verticalColumn.fiveStarsChartTitle');
      } else if (this.myMetric.indexOf('like-dislike') !== -1) {
        this.chartTitle = this.$t(
          'reports.verticalColumn.likeDislikeReportTitle',
        );
      }
    },
    // async setGradesByDate({ start, end }) {
    //   this.getGradesByDate({
    //     companyId: this.userAuth.companyId,
    //     actionId: this.myActionId !== '0' ? this.myActionId : null,
    //     startDate: start,
    //     endDate: end,
    //     token: this.userAuth.token,
    //     ih1: this.myIh1 === '0' ? null : this.myIh1,
    //     ih2: this.myIh2 === '0' ? null : this.myIh2,
    //   });
    // },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
  async mounted() {
    this.changeLabel();
    await this.setParams();
    EventBus.$on('refresh', async () => {
      await this.setParams();
      await this.renderBars();
    });
    EventBus.$on('drawer', async (payload) => {
      if (payload) {
        await this.setParams();
        await this.renderBars();
      }
    });
    EventBus.$on('load-nps', () => {
      this.loader = false;
      this.isLoading = false;
    });
    EventBus.$on('apply-filter-menu', () => {
      this.isLoading = true;
    });
    EventBus.$on('reset-filter-menu', () => {
      this.isLoading = true;
    });
    // EventBus.$on('change-dates', this.setGradesByDate);
    // let empty = true;

    // this.series[0].data.map((item) => {
    //   if (item !== 0) {
    //     empty = false;
    //   }
    //   return true;
    // });

    if (this.series.length === 0) {
      this.loader = false;
      this.chartOptions = {
        title: {
          align: 'left',
          text: this.$t('reports.verticalColumn.chartTitle'),
          style: {
            color: '#5f6368',
          },
        },
        chart: {
          type: 'column',
          height: 350,
          spacing: [25, 20, 25, 20],
          borderRadius: 4,
          borderColor: 'rgba(0, 0, 0, 0.09)',
          borderWidth: 0.7,
          style: {
            fontFamily:
              '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
            fontSize: '12px',
            width: '100%',
          },
        },
        xAxis: {
          categories: ['10', '9', '8', '7', '6', '5', '4', '3', '2', '1', '0'],
          visible: true,
          labels: {},
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false,
          },
          max: 0,
          title: {
            text: '',
          },
          stackLabels: {
            enabled: true,
            fontWeight: 'bold',
          },
        },
        series: [
          {
            name: this.$t('reports.verticalColumn.chartSeries'),
            colorByPoint: true,
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
        legend: {
          enabled: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.1,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            },
          },
          series: {
            groupPadding: 0,
            pointPadding: 0.05,
            pointWidth: 40,
            borderWidth: 0,
          },
        },
      };
    }
  },

  beforeDestroy() {
    // EventBus.$off('change-dates');
    EventBus.$off('drawer');
    EventBus.$off('refresh');
    EventBus.$off('apply-filter-menu');
    EventBus.$off('reset-filter-menu');
  },
};
</script>

<style lang="scss" scoped>
.graph {
  border: 1px solid rgba(0, 0, 0, 0.09);
  padding: 18px 0;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  border-radius: 4px;
  background-color: #fff;
  height: 350px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  padding: 20px;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/vertical-column/index.vue